import React, { useEffect, useState } from "react";
import { Newspaper } from "lucide-react";
import { api } from "@/lib/api";

const CATS = {
  headline: "Berita Headline", showtynion_trip: "Showtynion Trip", beauty_on_you: "Beauty on You (Vol 1-6)",
  jastip_elite: "Jastip Elite", clbk: "CLBK — Curhat Lagi Bersama Kita", blind_date: "Blind Date",
  fwb: "FWB — Friends With Beauty", mualab: "MUALAB",
};
const catLabel = (id) => CATS[id] || id;

export default function MemberNews() {
  const [news, setNews] = useState([]);
  useEffect(() => { api.get("/news").then((r) => setNews(r.data)).catch(() => {}); }, []);

  if (news.length === 0) {
    return (
      <div className="rounded-2xl border border-dashed border-border bg-white/50 py-16 text-center text-sm text-muted-foreground" data-testid="member-news-empty">
        <Newspaper className="w-6 h-6 mx-auto mb-2 text-showty-red/50" /> Belum ada berita
      </div>
    );
  }

  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="member-news-list">
      {news.map((n) => (
        <article key={n.id} className="rounded-2xl border border-border bg-white overflow-hidden flex flex-col" data-testid={`member-news-${n.id}`}>
          <div className="h-40 bg-showty-pink/30 overflow-hidden">
            {n.cover_image && <img src={n.cover_image} alt={n.title} className="w-full h-full object-cover" />}
          </div>
          <div className="p-5 flex flex-col flex-1">
            <span className="text-[11px] uppercase tracking-wide font-semibold text-showty-red">{catLabel(n.category)}</span>
            <h4 className="mt-2 font-display text-xl text-showty-navy">{n.title}</h4>
            {n.date && <p className="text-xs text-muted-foreground mt-0.5">{n.date}</p>}
            <p className="mt-2 text-sm text-muted-foreground whitespace-pre-wrap flex-1">{n.body}</p>
            {n.author && <p className="mt-3 text-xs text-muted-foreground">oleh {n.author}</p>}
          </div>
        </article>
      ))}
    </div>
  );
}
